export enum BadgeVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  low = 'low',
  high = 'high'
}

export enum BadgeType {
  count = 'count',
  label = 'label',
  marker = 'marker'
}

export enum BadgePosition {
  topLeft = 'topLeft',
  topRight = 'topRight',
  bottomLeft = 'bottomLeft',
  bottomRight = 'bottomRight'
}

export enum BadgeSize {
  sm = 'sm',
  md = 'md'
}

export type CssClassMap = { [className: string]: boolean };
